export default __webpack_public_path__ + "7961f2bc72191f5787814ecc4e1eeac8.svg";